const LeaveReasonMasterActionTypes = {
	/** ****************************** LEAVE REASON MASTER *********************** */
	LEAVE_REASON_MASTER_START: 'leave_reason_master_start',
	LEAVE_REASON_MASTER_SUCCESS: 'leave_reason_master_success',
	LEAVE_REASON_MASTER_FAILURE: 'leave_reason_master_failure',
	LEAVE_REASON_MASTER_RESPONSE_CHANGED: 'leave_reason_master_response_changed',
	LEAVE_REASON_MASTER_RESPONSE_REST_START: 'leave_reason_master_response_rest_start',
	LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS: 'LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS',
	UPDATE_LEAVE_REASON_MASTER_START: 'UPDATE_LEAVE_REASON_MASTER_START',
	UPDATE_LEAVE_REASON_MASTER_SUCCESS: 'UPDATE_LEAVE_REASON_MASTER_SUCCESS',
	UPDATE_LEAVE_REASON_MASTER_FAILURE: 'UPDATE_LEAVE_REASON_MASTER_FAILURE',
	UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_START:
		'UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_START',
	UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS:
		'UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS',
	UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE:
		'UPDATE_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE',
	ADD_LEAVE_REASON_MASTER_START: 'ADD_LEAVE_REASON_MASTER_START',
	ADD_LEAVE_REASON_MASTER_SUCCESS: 'ADD_LEAVE_REASON_MASTER_SUCCESS',
	ADD_LEAVE_REASON_MASTER_FAILURE: 'ADD_LEAVE_REASON_MASTER_FAILURE',
	ADD_LEAVE_REASON_MASTER_RESPONSE_REST_START: 'ADD_LEAVE_REASON_MASTER_RESPONSE_REST_START',
	ADD_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS: 'ADD_LEAVE_REASON_MASTER_RESPONSE_REST_SUCCESS',
	ADD_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE: 'ADD_LEAVE_REASON_MASTER_RESPONSE_REST_FAILURE',

	// Encryption keys
	LEAVE_REASON_MASTER_KEY: 'GetAllLeaveReasonDetailsFromWeb',
	UPDATE_LEAVE_REASON_MASTER_KEY: 'UpdateLeaveReasonDetailsBasedonReasonIDFromWeb',
	ADD_LEAVE_REASON_MASTER_KEY: 'AddLeaveReasonDetailsFromWeb',
};

export default LeaveReasonMasterActionTypes;
